/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { UserAvatarFragmentDoc } from '../users/UserAvatar.generated.js';
export type LastModifiedInfoBoxFragment = { __typename: 'LastModifiedInfo', at: any, by?: { __typename: 'User', id: string, firstname: string, familyname: string, avatar?: { __typename: 'AttachmentSnapshot', id: string, url: string } | null } | null };

export const LastModifiedInfoBoxFragmentDoc = gql`
    fragment LastModifiedInfoBox on LastModifiedInfo {
  at
  by {
    id
    ...UserAvatar
  }
}
    ${UserAvatarFragmentDoc}`;